var map = {
	"./blue-alpha.svg": 78633,
	"./brown-alpha.svg": 41331,
	"./cyan-alpha.svg": 75886,
	"./green-alpha.svg": 92551,
	"./orange-alpha.svg": 17091,
	"./pink-alpha.svg": 92875,
	"./purple-alpha.svg": 36454,
	"./red-alpha.svg": 87830,
	"./teal-alpha.svg": 22555,
	"./yellow-alpha.svg": 77431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43734;